<template>
    <div class="box">
        <!-- <div class="top">
            <span>总计用户数：{{total}}</span>
        </div> -->
        <div class="content">
            <div v-for="item,index in user_items"  class="row">
                <div class="useravata"><img src="../../assets/images/img/user_customer.png" width="60" height="60" /></div>
                <div class="userinfo">
                    <div class="username">{{getUserId(item.userid)}}({{getMobile(item.mobile)}})</div>
                    <div class="c_info">
                        <div class="regdate">注册时间：{{getdate(item.regtime)}}</div>
                        <div class="c_ver"><img :src="item.isbuy?zyb:tyb"></div>
                    </div>
                    
                </div>
            </div>
            <div v-if="total==0" style="display: flex;align-items: center;justify-content:center;height: 400px;background-color: #f8f7f7;"><img src="../../assets/images/img/browser_magnifie_icon.png"  width="120" height="120"></div>
        </div>
        <div class="footer">
            <Page :current="page_index" :total="total" :page-size="page_size"  @on-change="flip" simple />
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/'
import ConstJson from "../../api/common/constjson.js"
import moment from 'moment'
let constJ = new ConstJson()
export default {
    name: 'mycustomer',
    data() {
        return {
            user_items:[],
            total:0,
            page_index:0,
            page_size:5,
            zyb:require("../../assets/images/img/user_pro.png"),
            tyb:require("../../assets/images/img/user_trial.png"),
        }
    },
    computed: {
        ...mapGetters(['sta']),
    },
    created() {
        // this.$nextTick(function() {
        //     this.getQrCodeUrl()
        // })
        this.getMyCustomer()


    },
    methods: {
        getMyCustomer(){
            console.log('getMyCustomer====>')
            let args = {
                page: this.page_index,
                line: this.page_size,
            }
            constJ.getCustomer(args).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.user_items=res.item.items
                        this.total=res.item.total
                        this.page_index=res.item.page
                        this.$emit('on-success',this.total)
                    }
                }
            })
        },
        getdate(t){
            //console.log(t)
            // let t1 = moment(t).utcOffset(0).format("YYYY-MM-DD HH:mm:ss")
            let t1 = moment(t).utcOffset(0).format("YYYY-MM-DD")
            //let t1 =moment(t).toISOString() 
            return t1
        },
        getMobile(value){
            let v=value.replace(value.substring(3,7),'****')
            return v
        },
        getUserId(val){
            let reg = /^(.{2}).{3}(.*)$/;;
            if (val) {
            return val.replace(reg, "$1***$2");
            }
        },
        flip(page){
           console.log(page) 
           this.page_index=page
           this.getMyCustomer()
        }
    }
}
</script>
<style lang="less" scoped>
.box{
    height: 520px;
    background: #F7F8F9;
    display: flex;
    flex-direction: column; 
    .top{
        background: #2878FF;
        display: flex;
        flex:1;
        span{
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #fff;
            line-height: 24px;
            display: flex;
            align-items:center;
            padding-left:20px;
        }
    }
    .content{
        flex:5;
        display: flex;
        flex-direction: column; 
        overflow-y: auto;
        .row{
            height: 80px;//限制单行高度
            margin:10px 20px;
            background: #fff;
            border-radius: 8px;
            display: flex;
            flex-direction: row; 
            .useravata{
                display: flex;
                flex:2;
                align-items:center;
                justify-content:center;
            }
            .userinfo{
                display: flex;
                flex:5;
                flex-direction: column;
                width:100%;
                 .username{
                    display: flex;
                    align-items:flex-end;
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #000000;
                    height: 50%;

                 }
                 .c_info{
                    display: flex;
                    flex-direction: row; 
                    // background-color: gray;
                    align-items: center;
                    height: 50%;
                    .regdate{
                        display: flex;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #999999;
                        // align-items:flex-start;
                        width: 70%;
                    }
                    .c_ver{
                        display: flex;
                        // background-color: green;
                        align-items:center;
                        justify-content:center;
                        height: 100%;
                        width: 30%;
                        img{
                            display: flex;
                            height:22px;
                            width: auto;
                        }
                    }
                 }
                 

            }
        }
    }
    .footer{
        padding-top: 10px;
        background: white;
        display: flex;
        flex:0.2;
        justify-content:center;
    }
}


</style>